import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { Column } from "@ant-design/charts";
import { confirmDialog } from "primereact/confirmdialog";
import { Checkbox } from "primereact/checkbox";
import { toast } from "react-toastify";
import { deleteSendDays } from "../../../../services/Enterprise/WhatsppConfig/deleteSendDays";
import EmailEdit from "./EmailEdit";
import Switch from "../../../../components/input/Switch";
import { putSendDays } from "../../../../services/Enterprise/Email/putSendDays";
import { useParams } from "react-router-dom";

export default function EmailConfigSubject({
  setObjData,
  setActiveIndex,
  send_days,
  isLoading,
  refetch,
  handleCheckboxChange,
}) {
  const [modalEdit, setModalEdit] = useState(false);
  const [sendRowData, setSendRowData] = useState([]);
  const { id: enterpriseId } = useParams();
  const form = useForm();
  const errors = form.formState.errors;
  const columns = [
    { field: "days", header: "Quantidade de dias" },
    {
      field: "before_or_after",
      header: "Antes / Após Vencimento",
      body: (rowData) => {
        return rowData.before_or_after == "before" ? "Antes" : "Após";
      },
    },
    { field: "reply_to", header: "Email Resposta" },
    { field: "reply_to_name", header: "Assunto de Resposta" },
    { field: "text", header: "Mensagem" },
  ];

  const removeOption = (e, rowData) => {
    e.preventDefault();
    confirmDialog({
      message: "Deseja fazer a exclusão?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => sendDaysDelete(rowData.id),
    });
  };

  const sendDaysDelete = async (id) => {
    const notification = toast.loading("Por favor aguarde...");

    try {
      await deleteSendDays(id);
      await refetch();

      toast.update(notification, {
        render: "Dia de envio deletado com sucesso!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      toast.update(notification, {
        render: "Não foi possível deletar o dia de envio!",
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    }
  };

  function submitEdit(rowData) {
    setSendRowData(rowData);
    setModalEdit(true);
  }

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  const handleSwitchChange = async (e, rowData) => {
    var status, message;
    //    console.log(e);
    if (e) {
      status = 1;
      message = "Email habilitado com sucesso.";
    } else {
      status = 0;
      message = "Email desabilitado com sucesso.";
    }
    //    console.log(rowData);
    const newData = {
      ...rowData,
      enterprise_id: enterpriseId,
    };
    newData.status = status;

    const notification = toast.loading("Por favor aguarde...");

    try {
      await putSendDays(newData);
      toast.update(notification, {
        render: message,
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (err) {
      toast.update(notification, {
        render: "Falha ao executar a ação!",
        autoClose: 5000,
        type: "error",
        theme: "colored",
        isLoading: false,
      });
    }
  };

  useEffect(() => {
    // console.log(send_days)
    form.setValue(
      "reply_email_subject",
      `${send_days?.[0]?.reply_email_subject}`
    );
    form.setValue("reply_email", `${send_days?.[0]?.reply_email}`);
    form.setValue("sender_email", `${send_days?.[0]?.sender_email}`);
    form.setValue("subject_email", `${send_days?.[0]?.subject_email}`);
  }, [send_days]);

  return (
    <>
      {!send_days ? (
        <Skeleton variant="rect" width="100%" height={300} />
      ) : (
        <div className="px-2 pb-3">
          <DataTable
            rows={8}
            paginator
            stripedRows
            showGridlines
            sortMode="multiple"
            selectionMode="multiple"
            rowsPerPageOptions={[8, 10, 12]}
            value={send_days}
            loading={isLoading}
            emptyMessage="Nenhuma Informação foi encontrada."
            tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
          >
            <Column
              header="Habilitar"
              body={(rowData) => (
                <div className="text-center">
                  <Switch
                    name="installments_interest_entry"
                    control={form.control}
                    checked={rowData.status == 1 ? true : false}
                    onChange={(e) => handleSwitchChange(e, rowData)}
                    getFormErrorMessage={getFormErrorMessage}
                  />
                </div>
              )}
            />
            {columns.map((col) => (
              <Column
                sortable
                key={col.field}
                field={col.field}
                header={col.header}
                body={col.body}
              />
            ))}
            <Column
              header="Ações"
              body={(rowData) => (
                <div className="d-flex">
                  <div>
                    <button
                      className="btn btn-warning btn-btn-sm mx-2"
                      onClick={() => submitEdit(rowData)}
                    >
                      <i className="fa-regular fa-pen-to-square"></i>
                    </button>
                  </div>
                  <div className="mr-2">
                    <button
                      className="btn btn-danger btn-btn-sm"
                      onClick={(e) => removeOption(e, rowData)}
                    >
                      <i className="fa-solid fa-trash-can"></i>
                    </button>
                  </div>
                </div>
              )}
            />
          </DataTable>
          <EmailEdit
            refetch={refetch}
            rowData={sendRowData}
            visible={modalEdit}
            setVisible={setModalEdit}
          />
        </div>
      )}
    </>
  );
}
